export default __webpack_public_path__ + "static/media/15-ThreeMileCreek.689d5ff7.jpeg";